import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, ReactiveFormsModule } from '@angular/forms';
import { HypoControlsBaseComponent } from '@app/components/form-components/hypo-control-base/hypo-control-base.component';
import { FlexModule } from '@angular/flex-layout';
import { MatError, MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { TooltipComponent } from '@app/components/tooltip/tooltip.component';

@Component({
    selector: 'app-hypo-datepicker',
    templateUrl: './hypo-datepicker.component.html',
    styleUrls: ['./hypo-datepicker.component.scss'],
    imports: [
        FlexModule,
        MatFormField,
        ReactiveFormsModule,
        MatInput,
        MatDatepickerToggle,
        MatDatepicker,
        MatError,
        DatePipe,
        MatSuffix,
        MatFormField,
        MatDatepickerInput,
        TooltipComponent,
    ],
})
export class HypoDatepickerComponent
    extends HypoControlsBaseComponent
    implements ControlValueAccessor, OnInit, OnDestroy
{
    @Input() label: string = '';
    @Input() min: Date;
    @Input() max: Date;

    constructor() {
        super();

        moment.fn.toJSON = function () {
            return this.toISOString(true);
        };
    }
}
